/**
 * Created by lenovo on 2017/3/16.
 */
import xhr from './../xhr/'

import { ellaUrl } from '../../path.config'
import {getUserId} from 'UTIL/common'
class UserService {
    //用户类型列表
    getUserTypeList({data}){
        return xhr({
            method: 'post',
            url: ellaUrl+'/usertype/searchList',
            body : data
        })
    }
    //用户类型删除
    userTypeDel(id){
        return xhr({
            method: 'get',
            url: ellaUrl+"/usertype/doDelete/"+id,
        })
    }
    //用户列表
    getUserList({data}){
        return xhr({
            method: 'post',
            url: ellaUrl+'/back/user/list',
            body : data
        })
    }
     //商戶列表
     getBusinessList({data}){
        return xhr({
            method: 'post',
            url: ellaUrl+'/merchant/getByPage',
            body : data
        })
    }
       //商戶列表启用禁用
      businessAble(id,state){
        return xhr({
            method: 'get',
            url: ellaUrl+'/merchant/able?merchantId='+ id +'&state=' + state,
        })
    }
    //编辑商户初始化
    businessinIt(id){
        return xhr({
            method: 'get',
            url: ellaUrl+'/merchant/init?merchantId='+ id 
        })
    }
      //编辑商户
      editBusiness({data}={}){
        return xhr({
            method: 'post',
            url: ellaUrl+'/merchant/edit',
            body : data
        })
    }
    //添加商戶
    addBusiness({data}={}){
        return xhr({
            method: 'post',
            url: ellaUrl+'/merchant/add',
            body : data
        })
    }
    //删除商户
    bussinessDel(id){
        return xhr({
            method:"delete",
            url:ellaUrl+'/merchant/del?merchantId='+id
        })
    }

   //区域授权
    zoomAuth ({agentBody}={}) {
        return xhr({
            method: 'post',
            url: ellaUrl+'/lease/zoom/auth',
            body:agentBody,
        })
    }
    //区域授权保存
    zoomSave({data}={}){
        return xhr({
            method: 'post',
            url: ellaUrl+'/lease/zoom/auth/save',
            body : data
        })
    }
    //停车场授权信息获取
    parkAuth({data}={}){
        return xhr({
            method: 'post',
            url: "http://10.18.11.41:9011/challenger"+'/lease/park/auth',
            body : data
        })
    }


    fetchUserByLoginName(loginName){
        return xhr({
            method:"get",
            url:ellaUrl+'/user/get/'+loginName
        })
    }

    getMenu(userId,menuId){
        return xhr({
            method:"get",
            url:ellaUrl+"/"+userId+"/"+menuId
        })
    }

    //用户新增初始化
    fetchUser(){
        return xhr({
            method: 'get',
            url: ellaUrl+'/user/toAdd',
        })
    }
    //用户新增或编辑
    saveUser({userBody}={}){
        return xhr({
            method: 'post',
            url: ellaUrl+'/user/doAddOrUpdate',
            body:userBody,
        })
    }

    //用户新增初始化
    initUserAdd(){
        return xhr({
            method:"get",
            url:ellaUrl+'/user/toAdd/'+sessionStorage.userId,
        })
    }

    //进入用户编辑
    toUserEdit(userId){
        return xhr({
            method: 'get',
            url: ellaUrl+'/user/toUpdate/'+userId+'/'+sessionStorage.userId,
        })
    }

    //开局根据用户id获取系统和菜单
    fetchButtonByUserId(userId,menuId){
        return xhr({
            method:"post",
            url:ellaUrl +'/index/getpre/'+userId+'/'+menuId,
        })
    }

    //运营商 代理商 服务商 分页查询
    userList({data}={}){
        return xhr({
            method:"post",
            url:ellaUrl +'/lease/operatorUser/page',
            body:data,
        })

    }
    //运营商 代理商 服务商禁用
    userDisable(id){
        return xhr({
            method : 'get',
            url :ellaUrl+"/lease/operator/disable/"+id
        })
    }
    //运营商 代理商 服务商启用
    userEnable(id){
        return xhr({
            method : 'get',
            url :ellaUrl+"/lease/operator/enable/"+id
        })
    }

    //获取页面元素
    getPaper(){
        return xhr({
            method:'post',
            url:ellaUrl+'/pageper/index',
        })
    }

    //获取页面元素子信息详情
    getPaperInfo({data}={}){
        return xhr({
            method:'post',
            url:ellaUrl+'/pageper/toUpdate',
            body:data
        })
    }

    //删除页面元素
    deletePaperInfo(id){
        return xhr({
            method:'get',
            url:ellaUrl+'/pageper/doDelete/'+id,
        })
    }

    //保存或修改页面元素
    saveOrUpdate({data}={}){
        return xhr({
            method:"post",
            url:ellaUrl+'/pageper/doAddOrUpdate',
            body:data
        })
    }

    //获取组织架构
    fetchOrg(){
        return xhr({
            method:"post",
            url:ellaUrl+'/org/index',
        })
    }
    //获取组织架构详情
    getOrgInfo(id){
        return xhr({
            method:"POST",
            url:ellaUrl+"/org/toUpdate/"+id,
        })
    }

    //删除组织架构
    deleteOrgInfo(id){
        return xhr({
            method:"get",
            url:ellaUrl+'/org/doDelete/'+id,
        })
    }
    //保存组织架构
    saveOrgInfo({data}={}){
        return xhr({
            method:"post",
            url:ellaUrl+'/org/doAddOrUpdate',
            body:data,
        })
    }

    deleteStaff(id){
        return xhr({
            method:"get",
            url:ellaUrl+'/user/test/delete/'+id,
        })
    }
    //重置密码
    resetPassword(id){
        return xhr({
            method:"get",
            url:ellaUrl+'/user/password/reset/'+id,
        })
    }
    getZoomsList(agentId){
        return xhr({
            method:'post',
            url : 'http://10.18.11.41:9011/challenger/lease/zoomsParks/get/'+agentId,
        })
    }
}





// 实例化后再导出
export default new UserService()


// WEBPACK FOOTER //
// ./modules/services/ella/userService.js